<template>
    <div class="insurance">
      <div class="top-bg"></div>
      <div class="info-box necessity">
        <div class="info-title">
          <div class="info-title-top">商户投保必要性</div>
          <div class="info-title-bot"></div>
        </div>
        <div class="info-content">
          <div class="necessary-content">
            <img src="../../assets/img/insurance/icon_one.png" alt="">
            <div class="necessary-text">风险保障：可转移意外损失风险，降低商户因为意外事故和自然灾害带来的直接经济损失。</div>
          </div>
          <div class="necessary-content">
            <img src="../../assets/img/insurance/icon_two.png" alt="">
            <div class="necessary-text">租赁合同中明确规定商户需购买装修期、营业期的相应保险，不购买保险属于违约。</div>
          </div>
        </div>
      </div>
      <div class="info-box advantage">
        <div class="info-title">
          <div class="info-title-top">合作渠道购买保险优点</div>
          <div class="info-title-bot"></div>
        </div>
        <div class="info-content">
          <div class="advantage-content">
            <img src="../../assets/img/insurance/icon_money.png" alt="">
            <div class="advantage-text">
              <div class="desc-title">低保费红利</div>
              <div class="desc-content">因万达广场高水平安全管理，出险率低于同行业，对于广场内商户，合作保险公司给予低于市场平均价费率。</div>
            </div>
          </div>
          <div class="advantage-content">
            <img src="../../assets/img/insurance/icon_good.png" alt="">
            <div class="advantage-text">
              <div class="desc-title">优质理赔服务</div>
              <div class="desc-content">使用万达大客户理赔渠道，理赔便捷、降低时间成本。</div>
            </div>
          </div>
          <div class="advantage-content">
            <img src="../../assets/img/insurance/icon_fast.png" alt="">
            <div class="advantage-text">
              <div class="desc-title">方便快捷出单</div>
              <div class="desc-content">扫码投保、当天出单、次日生效。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-box brands" v-if="brandsImgs.length">
        <div class="info-title">
          <div class="info-title-top">可以选择的保险品牌</div>
          <div class="info-title-bot"></div>
        </div>
        <div class="info-content">
          <div class="brand-content" v-for="brand in brandsImgs" :key="brand.id">
            <div class="brand-bg" :style="{
              background: `url(${brand.bannerPath}) no-repeat`,
              backgroundSize: '100% 100%'
            }"></div>
            <div class="detail-btn" @click="goDetail(brand)">{{refreshing ? '刷新中' : '查看详情' }}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getInsuranceList } from '../../api/insurance'
export default {
  name: 'Insurance',
  data() {
    return {
      brandsImgs: [],
    }
  },
  mounted() {
    this.initInfo()
  },
  methods: {
    onRefresh() {
      this.initInfo()
    },
    goDetail(brand) {
      if(!brand.isLink) {
        window.location.href = brand.linkPath
      }else {
        this.$router.push({
          name: 'insuranceDetail',
          params: {
            msg: brand.pageCopyWriting,
            contact: brand.contactInformation
          }
        })
      }
    },
    async initInfo() {
      const val = await getInsuranceList()
      this.brandsImgs = val
    }
  }
}
</script>

<style lang="less" scoped>
.insurance {
  background: #FEECD7;
  width: 100%;
  height: 100%;
  overflow: auto;
  .top-bg {
    background: url('../../assets/img/insurance/bj_top.png') no-repeat;
    background-size: 100% 100%;
    height: 180px;
  }
  .necessary-content {
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    display: flex;
    img {
      width: 12px;
      height: 12px;
      margin: 3px 5px 0 0;
    }
    .necessary-text {
      flex: 1;
      text-align: left;
      color: #666666;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .advantage-content {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    display: flex;
    img {
      width: 48px;
      height: 48px;
      margin: 0 10px 0 0;
    }
    .advantage-text {
      flex: 1;
      text-align: left;
      display: flex;
      flex-direction: column;
      .desc-title {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        margin-bottom: 4px;
        font-weight: bold;
      }
      .desc-content {
        color: #666666;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
  .brands {
    .info-content {
      display: flex;
      justify-content: flex-start;
    }
  }
  .brand-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 11px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .brand-bg {
      width: 102px;
      height: 102px;
      margin-bottom: 8px;
    }
    .detail-btn {
      background: rgba(228, 19, 53, 0.1);
      color: #FF6F00;
      padding: 0 12px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .info-box {
    margin: -7px 10px 40px;
    &:last-child {
      margin-bottom: 24px;
    }
    .info-title {
      position: relative;
      .info-title-top {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        font-weight: bold;
        font-size: 20px;
        color: #FFFFFF;
        width: 232px;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(270deg, #FAA23A 0%, #FF8A01 100%);
        border-radius: 20px;
      }
      .info-title-bot {
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 232px;
        height: 40px;
        background: linear-gradient(270deg, #FAA23A 0%, #FF8A01 100%);
        border-radius: 20px;
        opacity: 0.36;
      }
    }
    .info-content {
      padding: 40px 14px 16px;
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
    }
  }
}
</style>